<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <template>
      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Generate PRN</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" dense>
            <v-col sm="3">
              <v-icon color="error">*</v-icon>
              <v-autocomplete
                rounded
                dense
                required
                v-model="ay"
                :items="ay_list"
                item-text="ay"
                item-value="id"
                label="Academic Year"
                outlined
              />
            </v-col>
           
            <v-col sm="2">
              <v-btn
                class="mt-6 button"
                @click="fetch_form"
                :loading="fetch_btn_load"
                >Generate</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <br>
        <v-card class="box" v-if="this.show_table">
           <v-row justify="center" align="center">
            <v-col cols="12" sm="12" md="12" v-if="show_scuuess_table">
                    <template v-if="show_scuuess_table">
                       <v-toolbar flat dense class="toolbar">
                                        <v-toolbar-title>Success List</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                        <v-data-table :headers="success_table_headers" :items="successlist" sort-by class="elevation-1 mytable" dense :search="search" ></v-data-table>
                    </template>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="present_table">
                    <template v-if="present_table">
                       <v-toolbar flat dense class="toolbar">
                                        <v-toolbar-title>Already Present List</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                        <v-data-table :headers="failed_table_headers" :items="failedlist" sort-by class="elevation-1 mytable" dense :search="search" ></v-data-table>
                    </template>
                </v-col>
           </v-row>
        </v-card>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  components: {
  },
  data: () => ({
    search: "",
    fetch_btn_load: false,
    date: new Date().toISOString().substr(0, 10),
    snackbar_msg: "",
    color: "",
    snackbar: false,
    awspath: null,
    tenant: true,
    ay_list:[],ay:"",failedlist:[],successlist:[],show_scuuess_table:false,present_table:false,show_table:false,
    success_table_headers: [
        // { text: "Sr.NO", value: "count" },
        { text: "Learner", value: "learner_username" },
        { text: "Parent", value: "parent_username" }
    ],
     failed_table_headers: [
        // { text: "Sr.NO", value: "count" },
        { text: "Learner", value: "learner_username" },
        { text: "Parent", value: "parent_username" }
    ],
  }),
  watch: {
    // current_academic_year() {
    //   this.get_forms();
    // },
    date(val) {
      this.person_details.date_of_birth = this.formatDate(this.date);
    },
  },
  mounted() {
    this.get_ay_forms();
  },
  computed: {
   
  },
  created() {
    this.awspath = localStorage.getItem("awspath");
     this.tenant = localStorage.getItem("EPS-tenant");
  },
  methods: {
    get_ay_forms() {
      axios
        .post("/Admission/getAyForApplicationForms")
        .then((res) => {
          if (res.data.flag == "YES") {
            this.ay_list = res.data.ay_list;
            this.ay = res.data.cay;
          } else {
            //error
          }
        })
        .catch((error) => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
    },
    // get_forms() {
    //   if (this.current_academic_year != null) {
    //     const formData = {
    //       ay: this.current_academic_year,
    //     };
    //     axios
    //       .post("/Admission/get_forms", formData)
    //       .then((res) => {
    //         if (res.data.msg == "200") {
    //           this.forms_list = res.data.forms_list_new;
    //         }
    //       })
    //       .catch((error) => {
    //         // window.console.log(error);
    //       })
    //       .finally(() => {
    //         //close loader
    //       });
    //   }
    // },
    fetch_form() {
      if (!confirm("Are You Sure You Want To Generate All PRN...?")) return;
        const data = {
          ay: this.ay
        };
        axios
          .post("/Admission/getApplicationForms", data)
          .then((res) => {
            if (res.data.flag == "YES") {
              this.showSnackbar("green", "PRN Generated Successfully...!"); // show snackbar
              this.failedlist=res.data.failedlist
              this.successlist=res.data.successlist,
              this.show_scuuess_table=true
              this.present_table=true
              this.show_table=true
            } else if(res.data.flag == "No") {
               this.showSnackbar("red", res.data.snackbar); // show snackbar
            }
            else{
               this.showSnackbar("red", res.data.snackbar); // show snackbar
            }

          })
          .catch((error) => {
            window.console.log(error);
          })
          .finally(() => {
            //close loader
          });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style>
</style>